import { render } from "./FavoritesLayer.vue?vue&type=template&id=1c7a552f"
import script from "./FavoritesLayer.vue?vue&type=script&lang=js"
export * from "./FavoritesLayer.vue?vue&type=script&lang=js"

import "./FavoritesLayer.vue?vue&type=style&index=0&id=1c7a552f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__